// Renders an activity's `icon`: an <img> when it looks like a URL, otherwise the
// raw string (emoji / short glyph). Falls back to nothing when empty.
export default function ActivityIcon({ activity }) {
  const icon = activity?.icon;
  if (!icon) return null;
  const isUrl = /^(https?:)?\/\//i.test(icon) || icon.startsWith('/');
  if (isUrl) {
    return (
      <img
        className="act-icon act-icon--img"
        src={icon}
        alt=""
        loading="lazy"
        aria-hidden="true"
      />
    );
  }
  return <span className="act-icon" aria-hidden="true">{icon}</span>;
}
